import * as React from "react";

function SvgConcreteMixer(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path d="M9.33203 5.57642V6.41709H11.3523L10.9082 5.57642H9.33203Z" fill={fill ?? "black"} />
        <path
          d="M0.517266 2.16719L0 5.13008L5.07787 7.57816L7.18756 6.5458L7.75087 3.32277L6.11782 1.625L0.517266 2.16719Z"
          fill={fill ?? "black"}
        />
        <path
          d="M1.65748 6.63892C1.65748 6.61231 1.6523 6.58596 1.64222 6.56137C1.63215 6.53679 1.61739 6.51445 1.59878 6.49563C1.58017 6.47681 1.55808 6.46189 1.53377 6.4517C1.50945 6.44152 1.48339 6.43628 1.45707 6.43628C1.43076 6.43628 1.4047 6.44152 1.38038 6.4517C1.35607 6.46189 1.33397 6.47681 1.31536 6.49563C1.29675 6.51445 1.28199 6.53679 1.27192 6.56137C1.26185 6.58596 1.25667 6.61231 1.25667 6.63892V8.02178H0.620239V9.45667H1.5654C1.63719 9.13468 1.81519 8.84697 2.07014 8.64083C2.32509 8.43469 2.64181 8.32239 2.96825 8.32239C3.29469 8.32239 3.61141 8.43469 3.86636 8.64083C4.12131 8.84697 4.29931 9.13468 4.3711 9.45667H7.71031V8.02178H1.65748V6.63892Z"
          fill={fill ?? "black"}
        />
        <path
          d="M2.96843 10.9107C3.58615 10.9107 4.08692 10.4044 4.08692 9.77979C4.08692 9.15519 3.58615 8.64885 2.96843 8.64885C2.35071 8.64885 1.84995 9.15519 1.84995 9.77979C1.84995 10.4044 2.35071 10.9107 2.96843 10.9107Z"
          fill={fill ?? "black"}
        />
        <path
          d="M11.6269 5.03423C11.5357 4.86941 11.403 4.73194 11.2422 4.63575C11.0814 4.53957 10.8984 4.48809 10.7116 4.48656H8.33649V9.45665H9.69059C9.76238 9.13466 9.94038 8.84695 10.1953 8.64081C10.4503 8.43467 10.767 8.32237 11.0934 8.32237C11.4199 8.32237 11.7366 8.43467 11.9915 8.64081C12.2465 8.84695 12.4245 9.13466 12.4963 9.45665H13V7.44397L11.6269 5.03423ZM11.8626 6.72378C11.8443 6.75368 11.8188 6.7784 11.7885 6.79564C11.7581 6.81288 11.724 6.82208 11.6892 6.82236H9.1327C9.07929 6.82237 9.02804 6.80111 8.99002 6.76318C8.95201 6.72526 8.93029 6.67372 8.92958 6.61973V5.37104C8.93029 5.31705 8.95201 5.26551 8.99002 5.22759C9.02804 5.18966 9.07929 5.1684 9.1327 5.1684H11.0284C11.0646 5.1685 11.1 5.17848 11.131 5.19728C11.162 5.21608 11.1874 5.243 11.2045 5.2752L11.868 6.52388C11.8837 6.55498 11.8915 6.5896 11.8906 6.62453C11.8896 6.65947 11.88 6.6936 11.8626 6.72378Z"
          fill={fill ?? "black"}
        />
        <path
          d="M11.0847 10.9107C11.7024 10.9107 12.2032 10.4044 12.2032 9.77979C12.2032 9.15519 11.7024 8.64885 11.0847 8.64885C10.467 8.64885 9.96619 9.15519 9.96619 9.77979C9.96619 10.4044 10.467 10.9107 11.0847 10.9107Z"
          fill={fill ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgConcreteMixer;
